import React from 'react';
import { ErrorMessage, useField } from 'formik';

export const TextField = ({ label, ...props }) => {
    // console.log(label)
    // console.log(props)
    const [field, meta] = useField(props);
    // console.log(field.name)
    // console.log(meta)
    return (
        <div className="mb-2  ">
            <label htmlFor={field.name}>{label}</label>
            <input
                className={`form-control  ${meta.touched && meta.error && 'is-invalid'}`}
                {...field} {...props}
                autoComplete="off"
            />
            <ErrorMessage component="div" name={field.name} className="error" style={{ color: 'red' }} />
        </div>
    )
}